module.exports = __webpack_public_path__ + "footerleft-8a0ae0af.png";